import { forwardRef, type Ref, type SVGProps } from "react";
const IconHouseHeartOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M10.28 14.27a4.36 4.36 0 0 1 5.72-.38 4.36 4.36 0 0 1 7 3.45 4.32 4.32 0 0 1-1.28 3.07l-4.75 4.74a1.53 1.53 0 0 1-1 .38 1.4 1.4 0 0 1-.87-.31l-4.82-4.81a4.32 4.32 0 0 1 0-6.14M16 23.3l4.31-4.3a2.3 2.3 0 0 0 .69-1.66 2.33 2.33 0 0 0-.65-1.66 2.37 2.37 0 0 0-3.33 0l-1 1-1-1a2.38 2.38 0 0 0-3.33 0 2.33 2.33 0 0 0-.69 1.66 2.3 2.3 0 0 0 .69 1.66z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M27.29 11.4 17.2 1.9a2 2 0 0 0-2.4 0L4.71 11.4A2 2 0 0 0 4 12.93V28a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12.93a2 2 0 0 0-.71-1.53M6 28V12.93l10-9.41 10 9.41V28z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHouseHeartOutlineSVG);
ForwardRef.displayName = "IconHouseHeartOutline";
export { ForwardRef as IconHouseHeartOutline };
